<template>
  <div>
    <ValidationObserver ref="form">
      <form @submit.prevent="validate">
        <div class="form-row">
          <div class="col-12">
            <ValidationProvider
              name="fullName"
              rules="required|max:255"
              v-slot="{ passed, failed }"
            >
              <fg-input
                name="fullName"
                :error="failed ? 'Your name is required': null"
                :has-success="passed"
                required
                label="Your Name"
                placeholder=""
                max-length="255"
                v-model="displayName"
              />
            </ValidationProvider>
            <ValidationProvider
              name="email"
              rules="required|max:255|email"
              v-slot="{ passed, failed }"
            >
              <fg-input
                name="email"
                :error="failed ? 'A valid email address is required': null"
                :has-success="passed"
                type="email"
                required
                label="Your Email Address"
                placeholder=""
                max-length="255"
                v-model="displayEmail"
              />
            </ValidationProvider>
            <ValidationProvider
              name="password"
              rules="required|max:255|min:5"
              v-slot="{ passed, failed }"
            >
              <fg-input
                name="password"
                :error="failed ? 'A password of 5 characters minimum is required.': null"
                :has-success="passed"
                type="password"
                required
                label="Password"
                placeholder=""
                max-length="255"
                v-model="userSetupInfo.Password"
              />
            </ValidationProvider>
            <ValidationProvider
              name="password2"
              rules="required|max:255|min:5|confirmed:password"
              v-slot="{ passed, failed }"
            >
              <fg-input
                name="password2"
                :error="failed ? 'Both password fields must match.': null"
                :has-success="passed"
                type="password"
                required
                placeholder=""
                max-length="255"
                v-model="password2"
              />
            </ValidationProvider>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { extend } from 'vee-validate'
import { required, max, email, min, confirmed } from 'vee-validate/dist/rules'

extend('required', required)
extend('max', max)
extend('min', min)
extend('email', email)
extend('confirmed', confirmed)

export default {
  name: 'AcceptInvitationUserInfo',
  props: {
    invitationDetails: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data: function () {
    return {
      password2: '',
      userSetupInfo: {
        UserName: null,
        Password: null,
        FullName: null
      }
    }
  },
  mounted: function () {
    this.refresh()
  },
  computed: {
    displayName: {
      get: function () {
        if (this.userSetupInfo.FullName === undefined || this.userSetupInfo.FullName === null) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.userSetupInfo.FullName = this.invitationDetails.ScouterName
        }
        return this.userSetupInfo.FullName
      },
      set: function (newValue) {
        this.userSetupInfo.FullName = newValue
      }
    },
    displayEmail: {
      get: function () {
        if (this.userSetupInfo.UserName === undefined || this.userSetupInfo.UserName === null) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.userSetupInfo.UserName = this.invitationDetails.ScouterEmail
        }
        return this.userSetupInfo.UserName
      },
      set: function (newValue) {
        this.userSetupInfo.UserName = newValue
      }
    }
  },
  methods: {
    refresh: function () {
      this.userSetupInfo.UserName = this.invitationDetails.ScouterEmail
      this.userSetupInfo.FullName = this.invitationDetails.ScouterName
    },
    validate: function () {
      return this.$refs.form.validate().then(res => {
        this.$emit('on-validated', res, null, this.userSetupInfo)
        return res
      })
    }
  }
}
</script>
